import Script from 'next/script'

export const BlockthroughScripts = () => {
  return (
    <Script data-testid="bt-script" src="https://btloader.com/tag?o=5668634355564544&upapi=true" />
  )
}
